import { Card, Container, Divider, Header } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import React from "react";
import { func } from "prop-types";
import { connect } from "react-redux";
import { ProductLineShape } from "../../shapes/productLine.shape";
import ProductTagModalCard from "./productTagModalCard";
import { getProductLine } from "../../selectors/unit/productLines";
import { getUnitPath } from "../../selectors/unit";
import { withRouter } from "../../helpers/withRouter";

function ProductLinePicker({ productLine, onSelect }) {
  return (
    <Container>
      <Divider horizontal clearing fitted>
        <Header size="large">
          <FormattedMessage id="buyerPortal.roomBook.productLine.messages.required" />
        </Header>
      </Divider>
      <Divider hidden clearing />
      <Card.Group centered>
        {productLine?.tags.map(tagId => (
          <ProductTagModalCard
            key={tagId}
            tagDescription={productLine?.tagDescriptions[tagId]}
            onSelect={onSelect}
          />
        ))}
      </Card.Group>
      <Divider hidden clearing section />
    </Container>
  );
}

ProductLinePicker.propTypes = {
  productLine: ProductLineShape,
  onSelect: func
};
ProductLinePicker.defaultProps = {
  productLine: undefined,
  onSelect: undefined
};

const mapStateToProps = (state, props) => {
  const productLine = getProductLine(state, props);
  const unitPath = getUnitPath(props);
  const onSelect = props.onSelect
    ? props.onSelect
    : () => {
        props.router.push(unitPath);
      };

  return {
    productLine,
    onSelect
  };
};

export default withRouter(connect(mapStateToProps)(ProductLinePicker));
